"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CO2Tank = exports.State = exports.LEGACY_TAGS = void 0;
const effect_1 = require("effect");
const Mass = __importStar(require("../../../../../unit/mass"));
const _util_1 = require("./_util");
const Definition = __importStar(require("./common"));
const NAMESPACE = 'Culligan.Device.Capability.Consumable.Definition.CO2Tank';
const TAG = 'CO2Tank';
const LABEL = 'CO2 Tank';
// Stored tanks may still carry these, so a query on the stored tag has to match them too.
exports.LEGACY_TAGS = ['BigCO2Tank', 'MediumCO2Tank', 'SmallCO2Tank'];
// Supports legacy tags by converting them to "CO2Tank"
const Tag = effect_1.Schema.transformLiterals([TAG, TAG], ...exports.LEGACY_TAGS.map(tag => [tag, TAG]))
    .pipe(effect_1.Schema.propertySignature, effect_1.Schema.withConstructorDefault(() => TAG))
    .annotations({ identifier: `${NAMESPACE}.Tag` });
exports.State = Definition.BaseState.pipe(effect_1.Schema.extend(Definition.DepletableState)).annotations({
    identifier: `${NAMESPACE}.State`,
    title: `${LABEL} State`,
});
class CO2Tank extends Definition.DepletableInKilograms.extend(`${NAMESPACE}.${TAG}`)({ _tag: Tag, ...Definition.Fields }, {
    identifier: `${NAMESPACE}.${TAG}`,
    title: LABEL,
}) {
    static id = 'co2_tank';
    static label = LABEL;
    static category = Definition.Category.CO2Tank;
    static expirable = false;
    static hasBatch = false;
    static State = exports.State;
    /**
     * @param mass The {@link Definition.DepletableInKilograms.fields.rangeFullCapacity rangeFullCapacity} of the consumable
     * @param triggerAt Scalar of {@link mass} at which to consider the consumable nearly depleted; `0 <= n <= 1`
     * @returns a {@link CO2Tank} represented in {@link Mass.Kilogram Kilogram}
     */
    static fromMass(mass, triggerAt = 0.25) {
        const kg = Mass.convert(mass, 'Kilogram');
        const amountLabel = mass.amount.toLocaleString('en-US', {
            maximumFractionDigits: 3,
            /**
             * Prevent the usage of a "," for formatting numbers with more than 3 non-fractional digits ("thousands")
             * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#usegrouping
             */
            useGrouping: false,
        });
        return this.make({
            id: `co2_${amountLabel}_${Mass.getSymbol(mass._tag).toLowerCase()}`,
            name: `CO₂ Tank (${amountLabel} ${Mass.getSymbol(mass._tag)})`,
            rangeFullCapacity: kg,
            rangeTrigger: Mass.Kilogram.make({ amount: kg.amount * triggerAt }),
            rangeExhaust: Mass.Kilogram.make({ amount: 0 }),
        });
    }
    static catalogue = {
        // Pelican 2 / Twist
        'co2_5_lb': this.fromMass(Mass.Pound.make({ amount: 5 })),
        'co2_10_lb': this.fromMass(Mass.Pound.make({ amount: 10 })),
        'co2_20_lb': this.fromMass(Mass.Pound.make({ amount: 20 })),
        // GBFC / Purity
        // https://culliganorg-my.sharepoint.com/:x:/g/personal/darren_bamber_culligan_com/EXF-EHv82P9Fg7cWFwL1vvoBnbev28aAjM1jmhDAwM4iWg?wdOrigin=TEAMS-MAGLEV.p2p_ns.rwc&wdExp=TEAMS-TREATMENT&wdhostclicktime=1757434619728&web=1
        'co2_0.425_kg': this.fromMass(Mass.Kilogram.make({ amount: 0.425 })),
        'co2_0.5_kg': this.fromMass(Mass.Kilogram.make({ amount: 0.5 })),
        'co2_0.6_kg': this.fromMass(Mass.Kilogram.make({ amount: 0.6 })),
        'co2_1_kg': this.fromMass(Mass.Kilogram.make({ amount: 1 })),
        'co2_1.5_kg': this.fromMass(Mass.Kilogram.make({ amount: 1.5 })),
        'co2_2_kg': this.fromMass(Mass.Kilogram.make({ amount: 2 })),
        'co2_3_kg': this.fromMass(Mass.Kilogram.make({ amount: 3 })),
        'co2_3.5_kg': this.fromMass(Mass.Kilogram.make({ amount: 3.5 })),
        'co2_4_kg': this.fromMass(Mass.Kilogram.make({ amount: 4 })),
        'co2_5_kg': this.fromMass(Mass.Kilogram.make({ amount: 5 })),
        'co2_6_kg': this.fromMass(Mass.Kilogram.make({ amount: 6 })),
        'co2_7_kg': this.fromMass(Mass.Kilogram.make({ amount: 7 })),
        'co2_8_kg': this.fromMass(Mass.Kilogram.make({ amount: 8 })),
        'co2_9_kg': this.fromMass(Mass.Kilogram.make({ amount: 9 })),
        'co2_10_kg': this.fromMass(Mass.Kilogram.make({ amount: 10 })),
        'co2_20_kg': this.fromMass(Mass.Kilogram.make({ amount: 20 })),
        // HydroTap
        'co2_1100_g': this.fromMass(Mass.Gram.make({ amount: 1_100 })),
        'co2_2640_g': this.fromMass(Mass.Gram.make({ amount: 2_640 })),
        'co2_24_oz': this.fromMass(Mass.Ounce.make({ amount: 24 })),
        'co2_80_oz': this.fromMass(Mass.Ounce.make({ amount: 80 })),
    };
    static legacyCatalogueItemIdMap = {
        co2_5_lb_tmp: 'co2_5_lb',
        co2_10_lb_tmp: 'co2_10_lb',
        co2_20_lb_tmp: 'co2_20_lb',
    };
    /**
     * Twist devices in the USA should only expose the following catalogue items.
     *
     * See: https://culligan.atlassian.net/browse/PELC-344
     */
    static twistUsaCatalogueItemIds = [
        'co2_5_lb',
        'co2_10_lb',
        'co2_20_lb',
    ];
    static twistEmeaCatalogueItemIds = [
        'co2_0.425_kg',
        'co2_0.5_kg',
        'co2_0.6_kg',
        'co2_1_kg',
        'co2_1.5_kg',
        'co2_2_kg',
        'co2_3_kg',
        'co2_3.5_kg',
        'co2_4_kg',
        'co2_5_kg',
        'co2_6_kg',
        'co2_10_kg',
        'co2_20_kg',
    ];
    static CatalogueItemFromId = (0, _util_1.makeCatalogueItemFromId)(this).annotations({
        identifier: `${NAMESPACE}.CatalogueItemFromId`,
    });
}
exports.CO2Tank = CO2Tank;
Definition.satisfiesConstructor(CO2Tank);
//# sourceMappingURL=co2-tank.js.map